<template lang="pug">
.eyeball-wrapper(:style="eyeballStyle")
    .eyeball
        .iris-wrapper
            slot
                .iris
</template>
<script>
export default {
    name: 'eyeball',
    props: ['size'],
    computed: {
        eyeballStyle () {
            if (this.size) {
                return {
                    width: this.size + 'px',
                };
            }
            return {};
        }
    }
};
</script>
<style lang="sass" scoped>
.eyeball-wrapper
    position: relative
    width: 930px
    .eyeball
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 0
        padding-top: 100%
        background-image: url(~public/images/gzzoc/eyeball-inner.png), url(~public/images/gzzoc/eyeball-outer.png)
        background-repeat: no-repeat, no-repeat
        background-size: 44% 44%, 100% 100%
        background-position: bottom 50% right 50%, 0 0
        .iris-wrapper
            position: absolute
            top: 31.7%
            left: 31.7%
            width: 36.5%
            height: 36.5%
            .iris
                width: 100%
                height: 100%
                background: url(~public/images/gzzoc/iris.svg) no-repeat left top / 100% 100%
                mix-blend-mode: screen
</style>
